<template>
	<aside class="maps">
		<div class="selected-provider">
			<p class="selected-provider__header">Your Selected Location</p>
			<provider :data="selectedMarker" :dealer-id="dealerId"/>
		</div>
		<div class="google-maps"></div>
		<div class="maps-hover">
			<div class="content">
				<provider :data="hoveredMarker" :dealer-id="dealerId"/>
			</div>
		</div>
	</aside>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import EventBus from '../../../js/eventBus'
import gmapsInit from "../../../js/gmaps";
import Services from '../../mixins/services';
import Provider from './provider'

import moment from "moment";

export default {
	mixins: [Services],
	props: ['searchString', 'searchRadius', 'usingSearchString', 'dealerId'],
	components: {
		Provider
	},
	data: function () {
		return {
			google: null,
			geocoder: null,
			map: null,
			map_options: {},
			address_components: [],
			markers: [],
			selectedMarker: null,
			hoveredMarker: null,
			bounds: null,
			infoWindow: null,
			searchCenterCache: null,
		}
	},
	computed: mapState({
		globals: state => state.LocationSearch.globals,
		geoLocation: state => state.LocationSearch.geoLocation,
		firstResults: state => state.LocationSearch.firstResults,
		allSearchResults: state => state.LocationSearch.allSearchResults,
	}),
	methods: {
		isZipSearch() {
			return /^\d+$/.test(this.searchString);
		},
		getMappableResults() {
			const results = this.isZipSearch()
				? this.allSearchResults
				: this.firstResults;
			return results.filter((location) => (
				Number.isFinite(parseFloat(location.latitude)) &&
				Number.isFinite(parseFloat(location.longitude))
			));
		},
		async drop_pins() {
			this.address_components = this.getMappableResults().reduce(
				async (accu, location, i) => {
					const address_components = await accu;
					await new Promise((resolve) => {
						const marker = this.createMarker(location)
						this.bounds.extend(marker.getPosition());
						this.markers.push(marker);
						marker.addListener("click", () => {
							this.selectedMarker = marker.__meta;
						});
						marker.addListener('mouseover', (e) => {
							this.markerOnMouseover(marker);
						});
						marker.addListener('mouseout', () => {
							this.markerOnMouseout();
						});

						resolve(marker);
					});
					address_components.push(location);
					return address_components;
				},
				Promise.resolve([])
			);
		},
		markerOnMouseover(marker) {
			if (this.hoveredMarker) {
				return;
			} else {
				this.hoveredMarker = marker.__meta;
				const scale = Math.pow(2, this.map.getZoom());
				const nw = new this.google.maps.LatLng(
					this.map.getBounds().getNorthEast().lat(),
					this.map.getBounds().getSouthWest().lng()
				);
				const worldCoordinateNW = this.map.getProjection().fromLatLngToPoint(nw);
				const worldCoordinate = this.map.getProjection().fromLatLngToPoint(marker.getPosition());
				const markerOffset = new this.google.maps.Point(
					Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
					Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale)
				);
				const mapOffset = document.querySelector(".google-maps").getBoundingClientRect();
				const providerEl = document.querySelector(".maps-hover");
				const providerElOffset = providerEl.getBoundingClientRect();
				providerEl.style.visibility = "visible";
				
				providerEl.style.top = `${(mapOffset.y + markerOffset.y) - (providerElOffset.height / 2) - 50}px`;
				providerEl.style.left = `${(mapOffset.x + markerOffset.x) - (providerElOffset.width) - 30}px`;
			}
		},
		markerOnMouseout() {
			const providerEl = document.querySelector(".maps-hover");
			providerEl.style.visibility = "hidden";
			this.hoveredMarker = null;
		},
		createMarker(el) {
      const markerBlueSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 50 50" xml:space="preserve">
          <path style="fill: #065894" d="M25 32.04c-7.18 0-13.02-5.84-13.02-13.02S17.82 6 25 6s13.02 5.84 13.02 13.02S32.18 32.04 25 32.04zm0-24.59c-6.38 0-11.57 5.19-11.57 11.57S18.62 30.59 25 30.59s11.57-5.19 11.57-11.57S31.38 7.45 25 7.45z"/>
          <path style="fill: #065894" d="M25 49c-.21 0-.4-.09-.54-.24C12.76 35.81 7.1 24.91 7.62 16.36c.27-4.35 2.12-8.03 5.5-10.96 6.77-5.87 16.99-5.87 23.76 0 3.38 2.93 5.23 6.62 5.5 10.96.52 8.55-5.14 19.45-16.84 32.4-.14.15-.33.24-.54.24zm0-46.55c-3.91 0-7.81 1.35-10.93 4.05-3.07 2.66-4.76 6.01-5 9.95-.49 8.02 4.87 18.36 15.93 30.74 11.06-12.38 16.42-22.72 15.93-30.73-.24-3.94-1.92-7.29-5-9.95C32.82 3.8 28.91 2.45 25 2.45z"/>
          <path style="fill: #065894" d="M25 8c-.9 0-1.77.11-2.61.32h5.22C26.77 8.11 25.9 8 25 8zm4.52 1.54H19.41c-.32.19-.64.4-.94.62h11.61c-.18-.21-.37-.42-.56-.62zm1.42 1.85H17.08c-.32.33-.61.68-.89 1.04h15.22c-.12-.36-.28-.7-.47-1.04zm1.57 2.75c0 .32-.03.65-.08.99h2.86c-.19-.51-.42-1-.68-1.47h-2.12c.01.16.02.32.02.48zm-1.2 3.83h4.64c-.05-.55-.15-1.09-.28-1.61H32.1c-.22.57-.49 1.1-.79 1.61zm-7.45-2.12c.53 0 .99-.29 1.25-.72h6.5c.06-.34.1-.67.1-.99 0-.16-.01-.32-.02-.48H25.1a1.436 1.436 0 0 0-2.48 0h-7.23c-.26.47-.49.96-.68 1.47h7.9c.25.43.72.72 1.25.72zm7.67-5.69c-.28-.21-.58-.4-.88-.58.16.19.31.38.45.58h.43zm2.28 2.28c-.27-.37-.57-.72-.89-1.04h-1.08c.16.33.3.68.41 1.04h1.56zm-9.26 16.2c-.18.52-.32.97-.42 1.32.29.02.58.04.87.04 3.49 0 6.59-1.63 8.61-4.17h-7.89c-.5 1.01-.89 1.99-1.17 2.81zm2.09-4.49-.27.45h8.08c.4-.68.74-1.4.99-2.17h-7.6c-.41.54-.82 1.1-1.2 1.72zm4.59-7.79h-16.9c-.13.52-.22 1.06-.28 1.61h16.3c.35-.52.65-1.05.88-1.61zm-.76 2.84c-.51.67-1.06 1.33-1.63 2h6.94c.13-.65.2-1.32.21-2h-5.52zm-1.03 0H14.01c.01.68.08 1.35.21 2h13.57c.58-.7 1.14-1.36 1.65-2zm-13.05 6.63a10.98 10.98 0 0 0 6.94 4.04c.23-.85.71-2.37 1.5-4.04h-8.44zm9.57-2.11c.29-.46.58-.88.88-1.29H14.55c.25.76.59 1.49.99 2.17h9.91c.16-.29.33-.59.51-.88z"/>
        </svg>
      `
      const markerBlueSvgDataUrl = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(markerBlueSvg);

      return new this.google.maps.Marker({
				map: this.map,
				id: el.id,
				icon: {
					url: markerBlueSvgDataUrl,
					scaledSize: new google.maps.Size(60, 90),
				},
				position: {
					lat: parseFloat(el.latitude),
					lng: parseFloat(el.longitude),
				},
				__meta: {
					id: el.id,
					...el,
				}
			});
		},
		getRadiusBounds(center) {
			const miles = parseFloat(this.searchRadius) || 20;
			const lat = center.lat();
			const lng = center.lng();
			const latDelta = miles / 69;
			const lngDelta = miles / (69 * Math.cos(lat * Math.PI / 180));

			return new this.google.maps.LatLngBounds(
				new this.google.maps.LatLng(lat - latDelta, lng - lngDelta),
				new this.google.maps.LatLng(lat + latDelta, lng + lngDelta)
			);
		},
		getRadiusZoom(center) {
			const radiusMiles = parseFloat(this.searchRadius) || 20;
			const mapEl = this.map.getDiv();
			const mapSize = Math.min(mapEl.offsetWidth, mapEl.offsetHeight);
			const diameterMeters = radiusMiles * 2 * 1609.344;
			const metersPerPixelAtZoomZero = 156543.03392 * Math.cos(center.lat() * Math.PI / 180);

			return Math.log2((metersPerPixelAtZoomZero * mapSize) / diameterMeters);
		},
		async getZipSearchCenter() {
			if (this.searchCenterCache && this.searchCenterCache.searchString === this.searchString) {
				return this.searchCenterCache.center;
			}

			try {
				const response = await fetch(`https://api.zippopotam.us/us/${this.searchString}`);
				if (!response.ok) {
					throw new Error(`Zip lookup failed with status ${response.status}`);
				}

				const data = await response.json();
				const place = data.places && data.places[0];
				const latitude = parseFloat(place?.latitude);
				const longitude = parseFloat(place?.longitude);

				if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
					throw new Error('Zip lookup response did not include coordinates');
				}

				const center = new this.google.maps.LatLng(latitude, longitude);
				this.searchCenterCache = {
					searchString: this.searchString,
					center: center
				};

				return center;
			} catch (error) {
				console.warn('Location Search: unable to resolve zip code map center.', error);
				return null;
			}
		},
		async getSearchCenter() {
			if (this.isZipSearch()) {
				return await this.getZipSearchCenter();
			}

			if (!this.usingSearchString && this.geoLocation) {
				return new this.google.maps.LatLng(
					this.geoLocation.latitude,
					this.geoLocation.longitude
				);
			}

			if (this.searchString) {
				const searched_component = await this.create_address_component({address: this.searchString});
				if (searched_component) {
					return new this.google.maps.LatLng(
						searched_component.geometry.location.lat(),
						searched_component.geometry.location.lng()
					);
				}
			}

			const mappableResults = this.getMappableResults();
			if (mappableResults.length > 0) {
				return new this.google.maps.LatLng(
					parseFloat(mappableResults[0].latitude),
					parseFloat(mappableResults[0].longitude)
				);
			}

			return null;
		},
		async fitRadiusBounds() {
			const center = await this.getSearchCenter();
			if (!center) return;

			this.map.setCenter(center);
			this.map.setZoom(this.getRadiusZoom(center));
			this.map.setCenter(center);
		},
		async searchLocations() {
			const mappableResults = this.getMappableResults();
			this.selectedMarker = mappableResults[0];
			this.bounds = new google.maps.LatLngBounds();
			
			if (mappableResults.length > 0) {
				this.address_components = [];
				this.markers.forEach(function(marker) {
					marker.setMap(null);
				});
				this.markers = [];
				
				await this.drop_pins();
			} else {
				if (this.markers.length > 0) {
					this.markers.forEach(function(marker) {
						marker.setMap(null);
					});
					this.markers = [];
				}
			}

			if (this.isZipSearch()) {
				await this.fitRadiusBounds();
			} else if (mappableResults.length > 1) {
				this.map.fitBounds(this.bounds);
			} else if (mappableResults.length === 1) {
				this.map.setCenter(this.markers[0].getPosition());
				this.map.setZoom(12);
			}
		},
		create_address_component(location) {
			return new Promise((resolve) => {
				this.geocoder.geocode(
					{ address: location.address },
					(result, status) => {
						if (status !== "OK" || !result[0]) {
							resolve(false);
						}
						resolve(result[0]);
					}
				);
			});
		},
		init() {
			return new Promise(async resolve => {
				this.google = await gmapsInit(this.globals.apiKey);
				this.geocoder = new this.google.maps.Geocoder();

					this.map_options = {
						clickableIcons: false,
						gestureHandling: "cooperative",
						disableDefaultUI: true,
						isFractionalZoomEnabled: true,
						zoom: 12,
					};

				if (this.geoLocation) {
					this.map_options.center = new this.google.maps.LatLng(
						this.geoLocation.latitude,
						this.geoLocation.longitude
					);
				}

				this.map = new this.google.maps.Map(
					document.getElementsByClassName("google-maps")[0],
					this.map_options
				);
				resolve();
			})
		}
	},
	async mounted() {
		await this.init();
		if (this.getMappableResults().length > 0) {
			await this.searchLocations();
		}
	},
	watch: {
		searchString: function () {
			this.searchCenterCache = null;
		}
	}
}
</script>
